import React, { useEffect } from 'react';
import { AppContent, Tabs } from '@common/components';
import { useNavigate, useParams } from '@common/hooks';
import { ComplianceTable } from '@onboarding/components';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';

export function OrganizationCompliancePage() {
  const { tabKey } = useParams<{ tabKey: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    setBreadcrumbs([{ name: 'Compliance', path: '/works/compliance' }]);
  }, [tabKey]);

  return (
    <>
      <AppContent className="organization-compliance-page">
        <Tabs
          defaultActiveKey={tabKey || 'assignment'}
          onTabClick={(key: string) =>
            navigate(`/works/compliance/${key}`, { replace: true })
          }
        >
          <Tabs.Pane tab="expired" key="expired">
            <ComplianceTable
              entity="organization"
              defaultFilter={{
                assignmentState: ['onboarding', 'cleared', 'working'],
                expired: true,
              }}
              defaultOrder={{
                complianceState: 'ascend',
                expiresOn: 'ascend',
              }}
              filterKey="complianceTableExpired"
            />
          </Tabs.Pane>
          <Tabs.Pane tab="expiring" key="expiring">
            <ComplianceTable
              entity="organization"
              defaultFilter={{
                assignmentState: ['onboarding', 'cleared', 'working'],
                expiringSoon: true,
              }}
              defaultOrder={{
                complianceState: 'ascend',
                expiresOn: 'ascend',
              }}
              filterKey="complianceTableExpiring"
            />
          </Tabs.Pane>
        </Tabs>
      </AppContent>
    </>
  );
}
